import React from 'react';
import moment from 'moment-timezone';
import HoverMenu from 'ats/components/hover-menu/HoverMenu';
import SettingsTableSkeleton from '../SettingsTableSkeleton';
import { Icon } from '../../layout/misc/Icon';
import { ProfileImage } from '../../layout/misc/ProfileImage';
import { Switch } from '../../layout/form-fields/inputs/Switch';

export class TestsTable extends React.Component {
	getCreatedByDisplay(test) {
		return (
			<div className="thumb-table">
				<div className="thumb-label">
					<figure className="image is-24x24 is-inline-block">
						<ProfileImage
							className="is-rounded"
							src={test.createdByUser.imageUrl}
						/>
					</figure>
					<div className="is-image-label">
						{test.createdByUser.name ? test.createdByUser.name : ''}
					</div>
				</div>
			</div>
		);
	}

	isColumnSorted(column) {
		if (this.props.sort && this.props.sort.column === column) {
			const icon = this.props.sort.asc ? 'fa-chevron-up' : 'fa-chevron-down';
			return <Icon icon={icon} />;
		} else {
			return null;
		}
	}

	handleHeaderClick(column) {
		if (this.props.onSort) {
			this.props.onSort(column);
		}
	}

	getMenuItems(item) {
		return [
			{
				label: 'Edit Test',
				img: '/ats/icons/edit-icon.svg',
				onClick: () => {
					if (this.props.onEdit) {
						this.props.onEdit(item);
					}
				}
			},
			{
				label: 'Delete Test',
				img: '/ats/icons/trash-icon.svg',
				className: 'is-danger',
				onClick: () => {
					if (this.props.onDelete) {
						this.props.onDelete(item);
					}
				}
			}
		];
	}

	render() {
		// Helper for Sortable Table Headers
		const SortableTableHeader = ({
			children,
			className,
			identifier,
			...props
		}) => {
			return (
				<th
					className={`is-sortable ${className}`}
					onClick={() => this.handleHeaderClick(identifier)}
					{...props}>
					{children} {this.isColumnSorted(identifier)}
				</th>
			);
		};

		return (
			<table className="table is-fullwidth">
				<thead>
					<tr>
						<SortableTableHeader style={{ width: '10%' }} identifier="name">
							Name
						</SortableTableHeader>
						<SortableTableHeader style={{ width: '10%' }} identifier="version">
							Version
						</SortableTableHeader>
						<SortableTableHeader
							style={{ width: '15%' }}
							identifier="skillmeterTestId">
							Skillmeter Test Id
						</SortableTableHeader>
						<SortableTableHeader
							style={{ width: '10%' }}
							identifier="sampleSize">
							Sample Size
						</SortableTableHeader>
						<SortableTableHeader
							style={{ width: '10%' }}
							identifier="averageScore">
							Average Score
						</SortableTableHeader>
						<SortableTableHeader
							style={{ width: '17%' }}
							identifier={'createdBy'}>
							Created by
						</SortableTableHeader>
						<SortableTableHeader
							style={{ width: '10%' }}
							identifier="createdAt">
							Created at
						</SortableTableHeader>
						<th className="enabled-column">Enabled</th>
						<th className="actions-column" />
					</tr>
				</thead>
				{this.props.loading ? (
					<SettingsTableSkeleton columns={10} />
				) : !this.props.isEmpty ? (
					<tbody>
						{this.props.data.map(item => {
							return (
								<tr key={item.id} className={item.disabled ? 'disabled' : ''}>
									<td className="has-text-weight-bold">{item.name}</td>
									<td className="has-text-weight-medium">{item.version}</td>
									<td className="has-text-weight-medium">
										{item.skillmeterTestId}
									</td>
									<td className="has-text-weight-medium">{item.sampleSize}</td>
									<td className="has-text-weight-medium">
										{item.averageScore}
									</td>
									<td className="has-text-weight-medium">
										{this.getCreatedByDisplay(item)}
									</td>
									<td className="has-text-weight-medium">
										{moment(item.createdAt).fromNow()}
									</td>
									<td className="enabled-column">
										<Switch
											id={item.id}
											key={Math.random()}
											value={!item.disabled}
											onValueChange={value => {
												if (this.props.onDisable) {
													this.props.onDisable(item);
												}
											}}
										/>
									</td>
									<td className="actions-column">
										<HoverMenu
											id={item.id}
											position="left"
											buttonIcon={
												<img
													src="/ats/icons/three-dots-icon.svg"
													alt="More actions"
												/>
											}
											items={this.getMenuItems(item)}
										/>
									</td>
								</tr>
							);
						})}
					</tbody>
				) : null}
			</table>
		);
	}
}
